module.exports = __webpack_public_path__ + "img/37.62512a06.png";